import { render } from "./ThumbDashboard.vue?vue&type=template&id=7b976592&scoped=true"
import script from "./ThumbDashboard.vue?vue&type=script&lang=js"
export * from "./ThumbDashboard.vue?vue&type=script&lang=js"

import "./ThumbDashboard.vue?vue&type=style&index=0&id=7b976592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b976592"]])

export default __exports__